import { SPACES } from "@/lib/studio";

const SpaceCard = ({ space, className }) => (
  <article
    data-testid={`space-card-${space.id.toLowerCase().replace(/\s+/g, "-")}`}
    className={`group relative min-h-[280px] overflow-hidden rounded-md border border-white/[0.08] bg-[#121216] transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-[#FF3333]/50 ${className}`}
  >
    <img src={space.image} alt={space.id} className="absolute inset-0 h-full w-full object-cover opacity-50 transition-[opacity,transform] duration-700 group-hover:scale-105 group-hover:opacity-70" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-[#0A0A0C]/60 to-transparent" />
    <div className="relative flex h-full flex-col justify-end p-8">
      <span className="font-tech text-xs text-[#FF8C00]">{space.tag} /</span>
      <h3 className="mt-2 font-display text-2xl font-bold uppercase text-white sm:text-3xl">{space.id}</h3>
      <p className="mt-3 max-w-md text-sm text-zinc-300">{space.blurb}</p>
    </div>
  </article>
);

export const Spaces = () => (
  <section id="spaces" className="mx-auto max-w-7xl scroll-mt-20 px-6 py-24 md:px-12" data-testid="spaces-section">
    <div className="mb-12 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="eyebrow">The spaces</p>
        <h2 className="mt-4 font-display text-3xl font-bold uppercase tracking-tight text-white lg:text-4xl">Three rooms. One factory.</h2>
      </div>
      <p className="max-w-sm text-sm text-zinc-400">Choosing a space is optional — tell us where you want to work when you book, or leave it open.</p>
    </div>
    <div className="grid grid-cols-1 gap-4 md:grid-cols-12">
      <SpaceCard space={SPACES[0]} className="md:col-span-8 md:row-span-2 md:min-h-[580px]" />
      <SpaceCard space={SPACES[1]} className="md:col-span-4" />
      <SpaceCard space={SPACES[2]} className="md:col-span-4" />
    </div>
  </section>
);
